import { api } from '../../../helpers'
import { appConstants } from '../../../constants'
import { storage, swal } from '../../../libraries'

// action get list vote
export const fetchVote = () => {
  return dispatch => {
    dispatch(fetchVoteRequest())
    api.get('api/vote', { headers: { 'Authorization': JSON.parse(storage.getItem('token')) } })
      .then(res => {
        const { data: dataVote, message, success } = res.data
        if (success === true) {
          dispatch(loadVoteSuccess(dataVote))
        } else {
          storage.removeItem('vote')
          dispatch(loadVoteFailed(message))
        }
      })
      .catch((message) => loadVoteFailed(message))
  }
}

// send to reducer
const fetchVoteRequest = () => ({
  type: appConstants.GET_LIST_VOTE_REQUEST
})

const loadVoteSuccess = (dataVote) => ({
  type: appConstants.GET_LIST_VOTE_SUCCESS,
  payload: { dataVote }
})

const loadVoteFailed = (message) => ({
  type: appConstants.GET_LIST_VOTE_FAILED,
  payload: { message }
})

// action submit vote
export const submitVote = (data) => {
  return dispatch => {
    dispatch(submitVoteRequest())
    api.post('api/vote/select', data, { headers: { 'Authorization': JSON.parse(storage.getItem('token')) } })
  }
}

const submitVoteRequest = () => ({
  type: appConstants.SUBMIT_VOTE_REQUEST
})

const submitVoteSuccess = (data) => ({
  
})